export default [
  { text: "Brasileira", value: 0 },
  { text: "Outra", value: 1 },
];
